// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XwTk","title":"Header_title__3yb4q","left":"Header_left__3PrKX","clinicName":"Header_clinicName__3-elK"};